/* VNI Clarity: progressive enhancement only. No form submission, ad SDK, cookie,
 * storage, or cross-domain attribution capture is added by this script.
 * Optional generic events require BOTH explicit operator approval and Shopify
 * analytics consent. No URLs, names, email, phone values, health data or quotes
 * are included. content_for_header/app embeds still need an independent audit.
 */
(function () {
  'use strict';
  var observers = [];
  var seenPricing = false;
  var allowedEvents = new Set(['consultation_click', 'phone_click', 'pricing_view']);
  var allowedPlacements = new Set(['utility', 'header', 'hero', 'mobile_menu', 'mobile_rail', 'pricing', 'final', 'footer', 'physician_profile', 'content']);
  function analyticsAllowed() {
    if (window.VNI_ALLOW_ANALYTICS !== true) return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()); }
    catch (_) { return false; }
  }
  function emit(name, placement) {
    if (!allowedEvents.has(name) || !allowedPlacements.has(placement) || !analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'vni_' + name, vni_placement: placement});
  }
  function closeMenus(returnFocus) {
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) {
      menu.open = false;
      if (returnFocus) { var summary = menu.querySelector('summary'); if (summary) summary.focus(); }
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var action = target.closest('[data-vni-event]');
    if (action) emit(action.dataset.vniEvent, action.dataset.vniPlacement || 'content');
    if (target.closest('.mobile-menu a') || !target.closest('.mobile-menu')) closeMenus(false);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeMenus(true); });
  function mount() {
    observers.forEach(function (observer) { observer.disconnect(); }); observers = [];
    var rail = document.querySelector('.mobile-action');
    var hero = document.querySelector('.hero') || document.querySelector('.page-intro');
    var final = document.querySelector('.final-cta');
    if (rail && 'IntersectionObserver' in window) {
      var heroVisible = true, finalVisible = false;
      function updateRail() {
        var visible = !heroVisible && !finalVisible;
        rail.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-mobile-rail', visible && window.matchMedia('(max-width: 749px)').matches);
      }
      if (hero) {
        var heroObserver = new IntersectionObserver(function (entries) { heroVisible = entries[0].isIntersecting; updateRail(); }, {threshold:0});
        heroObserver.observe(hero); observers.push(heroObserver);
      }
      if (final) {
        var finalObserver = new IntersectionObserver(function (entries) { finalVisible = entries[0].isIntersecting; updateRail(); }, {threshold:0.08});
        finalObserver.observe(final); observers.push(finalObserver);
      }
    }
    var pricing = document.querySelector('#pricing');
    if (pricing && 'IntersectionObserver' in window) {
      var pricingObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !seenPricing && analyticsAllowed()) {
          seenPricing = true; emit('pricing_view', 'pricing'); pricingObserver.disconnect();
        }
      }, {threshold:0.2}); pricingObserver.observe(pricing); observers.push(pricingObserver);
    }
  }
  window.VNI = Object.freeze({mount:mount});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
